import { render, staticRenderFns } from "./back-to-top-button.vue?vue&type=template&id=40fd95fd"
import script from "./back-to-top-button.vue?vue&type=script&lang=js"
export * from "./back-to-top-button.vue?vue&type=script&lang=js"
import style0 from "./back-to-top-button.vue?vue&type=style&index=0&id=40fd95fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports